<template lang="pug">
div.field.is-fullwidth
  .control
    .select.is-fullwidth
      input.input(v-model='selected', type='date')

</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DatePicker",

  computed: {
    ...mapState(["date"]),
    selected: {
      get() {
        return this.$store.state.date;
      },
      set(value) {
        this.$store.commit("date", value);
      }
    }
  },
  props: {}
};
</script>

<style scoped lang="less">
</style>